'use client'

import Link from 'next/link'

interface SubMenuProps {
  items: any[]
}

const SubMenu = ({ items }: SubMenuProps) => {
  return (
    <ul className=" translate-y-1/4 absolute top-full left-0 min-w-[250px] flex-col bg-white opacity-0 invisible scale-y-0 group-hover:opacity-100 group-hover:visible group-hover:scale-y-100 transition-all duration-700 origin-top z-[99] shadow-lg rounded-md">
      {items?.map((item, idx) => (
        <li className="relative border-b border-black/10 w-full group/link" key={idx}>
          <Link
            href={item?.link?.url || '/'}
            className="block px-[20px] py-[10px] text-[16px] text-black font-medium hover:bg-destructive hover:text-white transition duration-500"
          >
            {item?.link?.label}
          </Link>

          <ul className="absolute top-0 left-full min-w-[250px] flex-col bg-white opacity-0 invisible scale-y-0 group-hover/link:opacity-100 group-hover/link:visible group-hover/link:scale-y-100 transition-all duration-700 origin-top z-[99] shadow-lg rounded-md">
            {!!item?.subMenuItems?.length && (
              <>
                {item?.subMenuItems?.map((item: any, idx: any) => (
                  <li key={idx}>
                    <Link
                      href={item?.link?.url || '/'}
                      className="block px-[20px] py-[10px] text-[16px] text-black hover:bg-destructive hover:text-white"
                    >
                      {item?.link?.label}
                    </Link>
                  </li>
                ))}
              </>
            )}
          </ul>
        </li>
      ))}
    </ul>
  )
}

export default SubMenu
